import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonStructured from "../../common-components/CommonStructured";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AMForm from "./AMForm";
import { fetchApprovalManagerData } from "../../../redux/reducers/apiSlice";
import { deleteApprovalManager } from "../../../data/ApiEndpoints";
import { formattedLongDate } from "../../common-data/Converts";
import Loader from "../../ui/Loader";

const ApprovalManager = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const { approvalManagerLoading, approvalManager } = useSelector(
    (state) => state.api
  );

  const iniTbDatas = {
    allApprovalManagers: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = (name, row) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardType: name,
      rowData: row,
    }));
  };

  const handleDelete = async (filter, endpoint) => {
    const handleConfirm = async () => {
      if (filter) {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: endpoint,
              queryParams: filter,
            })
          ).unwrap();

          console.log(response);

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getApprovalManagerList();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
  };

  function getApprovalManagerList() {
    dispatch(
      fetchApprovalManagerData({
        filters: {},
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getApprovalManagerList();
  }, []);

  useEffect(() => {
    if (approvalManager?.status && approvalManager?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allApprovalManagers: approvalManager.data || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allApprovalManagers: [],
      }));
    }
  }, [approvalManager]);

  const tbColumns = [
    {
      dataField: "for_ac_type",
      text: "Role",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.for_ac_type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "approval_centers",
      text: "gyms",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => onClickModal("approval_centers", row)}
          >
            view
          </span>
        );
      },
    },
    // {
    //   dataField: "user_mobile",
    //   text: "mobile",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.user_mobile || "NA"}</span>;
    //   },
    // },
    // {
    //   dataField: "user_email",
    //   text: "email",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data lowercase">{row?.user_email || "NA"}</span>
    //     );
    //   },
    // },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data lowercase minwidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className={`actionBtn icon edit`}
            onClick={() => onClickModal("edit", row)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            type="button"
            className={`actionBtn icon delete`}
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter, deleteApprovalManager);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash3-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#c71010",
                cursor: "pointer",
              }}
            >
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const tbColumnsGyms = [
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose
            title={`${
              modValues.cardType === "edit"
                ? "Edit Approval Manager"
                : modValues.cardType === "add"
                ? "Add Approval Manager"
                : modValues.cardType?.replace(/_/g, " ")
            } `}
            onClose={closeModal}
          />
          {modValues.cardType === "edit" || modValues.cardType === "add" ? (
            <AMForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() => getApprovalManagerList()}
              rowData={modValues.cardType === "edit" ? modValues.rowData : ""}
              isEdit={modValues.cardType === "edit"}
            />
          ) : modValues.cardType === "approval_centers" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable  mt30">
              <PaymentLinkTable
                tableData={modValues.rowData?.approval_centers || []}
                tableColumns={tbColumnsGyms}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <br />

      <CommonStructured
        pageHeading={""}
        createBtnTxt={"+ Add New Approval Manager"}
        createBtnTxt1={"Reload"}
        onClickCreateBtn={() => onClickModal("add", {})}
        onClickCreateBtn1={() => getApprovalManagerList()}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
        {approvalManagerLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allApprovalManagers}
            tableColumns={tbColumns}
          />
        )}
      </div>

      <div className="lead-logs-card-container leave-management-mobile-v only-mobile">
        <div className="all-leads-log mt30">
          {tbDatas.allApprovalManagers?.length > 0 &&
            tbDatas.allApprovalManagers.map((staff, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info">
                    <div className="log-card-top">
                      <h3 className="lead-name">{staff?.user_name || "NA"}</h3>

                      <span className={`lead-type staff-leave-cat`}>
                        {staff?.for_ac_type === "receptionist"
                          ? "Sales Executive"
                          : staff?.for_ac_type?.replace(/_/g, " ") || "NA"}
                      </span>
                    </div>

                    <div
                      className="card-other-info"
                      style={{ padding: "10px 20px" }}
                    >
                      <span className="value semi-bold">
                        {staff?.user_mobile || ""}
                      </span>

                      {staff?.email ? (
                        <span className="value email semi-bold">
                          {staff?.user_email || ""}
                        </span>
                      ) : null}

                      <span className="value semi-bold">
                        date added :
                        <b>
                          {" "}
                          {staff?.date_added
                            ? formattedLongDate(staff.date_added)
                            : "-"}{" "}
                        </b>
                      </span>
                    </div>

                    <div className="all-followuo-info-container">
                      <div className="all-btns lead-btn-axceed">
                        <div className="lead-log-box">
                          <button
                            className="lead-log edit-btn"
                            onClick={() => onClickModal("edit", staff)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil"
                              viewBox="0 0 16 16"
                              // style={{
                              //   width: "30px",
                              //   height: "30px",
                              // }}
                            >
                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                            </svg>
                          </button>

                          <span className="btn-label">Edit</span>
                        </div>

                        <div className="lead-log-box">
                          <button
                            className="lead-log delete-btn"
                            onClick={() => {
                              const uidFilter = {
                                uid: staff?.uid || "",
                              };
                              handleDelete(uidFilter, deleteApprovalManager);
                            }}
                          >
                            {approvalManagerLoading ? (
                              <Loader />
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash3-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                              </svg>
                            )}
                          </button>

                          <span className="btn-label">Delete</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ApprovalManager;
